/* eslint-disable no-unused-vars */
import { createAPIHandler, useOFetchRaw } from "@/plugins/ofetch";

const _MeAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/user/me.js").getMe>}  */
  getMe: createAPIHandler(
    ([query = undefined]) => [
      `/api/user/me`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/user/me.js").getMeWithBillingId>}  */
  getMeWithBillingId: createAPIHandler(
    ([billingId, committeeCode, query = undefined]) => [
      `/api/user/me/${encodeURIComponent(billingId)}/${encodeURIComponent(committeeCode)}`,
      { method: "GET", query }
    ]
  ),
};
export { _MeAPI as MeAPI };
